// DS3.9
import React, { useCallback, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import InputField from '@wix/da-ds/pkg/formControls/lego/InputField';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './HeaderSearchInput.scss';
const USERNAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9]$/;
const HeaderSearchInput = ({ className, searchQuery, searchBasePath, isLegacyHeader })=>{
    const { t } = useTranslation();
    const searchInputRef = useRef(null);
    const logBiEvent = useBiLogger();
    const handleSubmit = useCallback((e)=>{
        var _searchInputRef_current_value, _searchInputRef_current;
        e.preventDefault();
        const searchTerm = (_searchInputRef_current = searchInputRef.current) === null || _searchInputRef_current === void 0 ? void 0 : (_searchInputRef_current_value = _searchInputRef_current.value) === null || _searchInputRef_current_value === void 0 ? void 0 : _searchInputRef_current_value.trim();
        if (!searchTerm) {
            return; // dont allow empty search
        }
        const searchUrl = Url.searchLink(searchTerm, searchBasePath);
        const username = searchTerm.slice(1);
        const isCorrectUsername = searchTerm.startsWith('@') && USERNAME_REGEX.test(username);
        logBiEvent(BiData({
            evid: 710,
            search_terms: searchTerm,
            sectionname: 'popup'
        }));
        // Only search usernames if we are not on subdomain!
        if (isCorrectUsername && !isLegacyHeader) {
            const userLinkUrl = Url.userLink(username);
            // to test this locally do `.replace('.com', '.lan')`
            const http = new XMLHttpRequest();
            http.open('HEAD', userLinkUrl);
            http.onreadystatechange = function() {
                if (this.readyState === this.DONE) {
                    const doesUserExists = this.status === 200;
                    const redirectUrl = doesUserExists ? userLinkUrl : searchUrl;
                    window.location.assign(redirectUrl);
                }
            };
            http.send();
        } else {
            window.location.assign(searchUrl);
        }
    }, [
        isLegacyHeader,
        logBiEvent,
        searchBasePath
    ]);
    const handleInputKeyDown = useCallback((event)=>{
        if (event.key === 'Enter' || event.key === 'Return') {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit(event);
        }
    }, [
        handleSubmit
    ]);
    return /*#__PURE__*/ React.createElement("form", {
        className: c(s['search-form'], className),
        action: Url.searchLink(),
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(InputField, {
        id: "search-input",
        defaultValue: searchQuery,
        ref: searchInputRef,
        autoComplete: "off",
        className: s['input-field'],
        inputClassname: s['input'],
        placeholder: t('siteHeader.search'),
        "aria-label": t('siteHeader.search'),
        onKeyDown: handleInputKeyDown,
        prefix: /*#__PURE__*/ React.createElement(SearchIcon, {
            size: IconSize.SMALLER,
            disableDefaultColors: true,
            className: s['icon'],
            "aria-hidden": true
        }),
        onClick: ()=>{
            logBiEvent(BiData({
                evid: 700,
                link_name: 'search'
            }));
        }
    }));
};
HeaderSearchInput.displayName = 'HeaderSearchInput';
export default HeaderSearchInput;
